export const DIGITS_STRING_REGEX = /^\d+$/;
export const SUPPORT_PIN_LENGTH = 6;
